// import {
// 	GetLableByValue
// } from '@/utils'
import store from '@/store'

Date.prototype.Format = function (fmt) {
	let o = {
		"M+": this.getMonth() + 1, //月份
		"d+": this.getDate(), //日
		"h+": this.getHours(), //小时
		"m+": this.getMinutes(), //分
		"s+": this.getSeconds(), //秒
		"q+": Math.floor((this.getMonth() + 3) / 3), //季度
		"S": this.getMilliseconds() //毫秒
	};
	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
	}
	for (let k in o) {
		if (new RegExp("(" + k + ")").test(fmt)) {
			fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
		}
	}
	return fmt;
}
/**
 * 码表过滤器
 */
const CodeTable = (value, type) => {
	let str = '';
	if (value == 0 || value) {
		value += '';
		let e = store.state.baseCode;
		let d = e ? e : {};
		str = GetLableByValue(value, d[type] ? d[type] : []);
	}
	return str;
}

/**
 * 字符串截取过滤器
 */

const limit = (value, len = 0) => {
	let s = value ? value.toString() : '';
	if (s.length > len) {
		return s.substr(0, len) + "...";
	}
	return s;
}

/**
 * 时间过滤器
 */

const DateFormat = (value, reg = 'yyyy-MM-dd') => {
	if (value) {
		let d = new Date(value.replace(/\-/g, '/').replace('T', ' ').replace(/\.[\d]*$/, ''));
		return d.Format(reg);
	}
	return '';
}

/**
 * 学时过滤器
 */

const Period = (value) => {
	if (value) {
		return (value / 3600).toFixed(2)
	}
	return 0
}

/**
 * 会议类型
 */

const MeetingType = (value) => {
	switch (value) {
		case "MeetingType-105":
			return '党支部会';
			break
		case "MeetingType-102":
			return '党小组会';
			break
		case "MeetingType-104":
			return '学员大会';
			break
		case "MeetingType-103":
			return '党课';
			break
		case "MeetingType-107":
			return '民主评议';
			break
		case "MeetingType-100":
			return '支部委员会';
			break
		case "MeetingType-101":
			return '机构生活会';
			break
		case "MeetingType-106":
			return '开放式机构生活会';
			break
		case "MeetingType-108":
			return '主题党日';
			break

	}
}

export {
	CodeTable,
	limit,
	DateFormat,
	Period,
	MeetingType
}
